module.exports = __webpack_public_path__ + "img/wx-miaosha.5f568fde.png";